import { useRef, useState } from "react";
import Button from "../../gui/Button/Button";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import { IFood } from "../../shared/IFood";
import DialogTitle from "../Dialogs/DialogTitle";
import Form, { useForm } from "../../gui/Form/Form";
import FormControl from "../../gui/Form/FormControl";
import TextInput, { Formatters, ITextInput } from "../../gui/TextInput/TextInput";
import Validators from "../../gui/Form/Validators";
import Foods from "../../data/Foods";
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider";

export function UnitSettingsDlg(props:{food:IFood}) {
    const [busy,setBusy] = useState<boolean>(false)
    const {popOverlay} = useOverlay()
    const {valid} = useForm()
    const refAmount = useRef<ITextInput|null>(null)
    
    const {addSnackbar} = useSnackbar()
    const onClose = () => popOverlay("units")
    const onSave = async () => {
        if (busy || !refAmount.current?.value) return
        else setBusy(true)
        try {
            await Foods.i.setCup2grams(props.food._id, Number(refAmount.current.value) )
        }catch(e){
            setBusy(false)
            return addSnackbar(e)
        }
        onClose()
    }

    const grams = Foods.cup2gram(props.food)
    const defaultValue = grams ? grams.toString() : ""
    return <>
        <DialogTitle title="Unit Settings" onClose={onClose}/>
        <div className="content">
            <p>How much does 1 CUP of {props.food.name} weigh in grams?</p>
            <FormControl validators={[Validators.PositiveNumber("Grams")]}><TextInput ref={refAmount} formatter={Formatters.PositiveRealNumber} defaultValue={defaultValue} placeholder="Grams"/></FormControl>
        </div>
        <div className="actions">
            <Button variant="text" size="regular" onClick={onClose}>CANCEL</Button>
            <Button variant="contained" size="regular" color="primary" onClick={onSave} disabled={busy||!valid}>SAVE</Button>
        </div>
    </>
}

export function useUnitSettings(){
    const {addOverlay} = useOverlay()
    const showUnitSettings = (food:IFood) => {
        addOverlay("units", {children:<Form defaultValid={Foods.cup2gram(food)>0}><UnitSettingsDlg food={food}/></Form>, className:"dialog popup"})
    }
    return {showUnitSettings}
}